module.exports = __webpack_public_path__ + "img/currency-dollar-outline-blue.e0850c5c.svg";